import { render, staticRenderFns } from "./WuliuDialog.vue?vue&type=template&id=49896d82&"
import script from "./WuliuDialog.vue?vue&type=script&lang=js&"
export * from "./WuliuDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports